module.exports = __webpack_public_path__ + "img/folder-blue.ca44a076.svg";